import { isCpqType } from '@server/documentation';

export const ALL_CATEGORY = 'all';

export const categories = [
  { id: ALL_CATEGORY, label: 'All' },
  { id: 'automation', label: 'Automation' },
  { id: 'code', label: 'Code' },
  { id: 'schema', label: 'Schema' },
  { id: 'user-interface', label: 'User Interface' },
  { id: 'security', label: 'Security' },
  { id: 'agentforce', label: 'Agentforce' },
  { id: 'integration', label: 'Integration' },
  { id: 'custom-metadata', label: 'Custom Metadata' },
  { id: 'CPQ', label: 'CPQ' },
];

// Function to determine category based on table + __mdt rule
export const getMetadataCategory = (metadataType: string): string => {
  // First check if it ends with __mdt - goes to Custom Metadata
  if (metadataType.endsWith('__mdt')) {
    return 'custom-metadata';
  }

  // Check for CPQ metadata types using existing function
  if (isCpqType(metadataType)) {
    return 'CPQ';
  }

  // Then check the table mapping
  const tableMapping: Record<string, string> = {
    // Agentforce
    Bot: 'agentforce',
    BotVersion: 'agentforce',
    BotBlock: 'agentforce',
    BotNavigation: 'agentforce',
    MLDataDefinition: 'agentforce',
    MLPredictionDefinition: 'agentforce',
    AIApplication: 'agentforce',
    AIApplicationConfig: 'agentforce',
    AIReplyRecommendation: 'agentforce',
    ConversationDefinition: 'agentforce',
    MessagingChannel: 'agentforce',
    ServicePresenceStatus: 'agentforce',
    PresenceDeclineReason: 'agentforce',
    PresenceUserConfig: 'agentforce',
    QueueRoutingConfig: 'agentforce',
    ServiceChannel: 'agentforce',
    SkillRequirement: 'agentforce',
    Skill: 'agentforce',
    AgentWork: 'agentforce',
    LiveChatDeployment: 'agentforce',
    LiveChatButton: 'agentforce',
    LiveAgentConfig: 'agentforce',
    ChatBotDialog: 'agentforce',
    BotIntent: 'agentforce',
    BotVariable: 'agentforce',
    BotSlot: 'agentforce',
    SkillType: 'agentforce',
    SchedulingObjective: 'agentforce',
    SchedulingRule: 'agentforce',
    TimeSheetTemplate: 'agentforce',
    EmbeddedServiceFlowConfig: 'agentforce',
    EmbeddedServiceMenuSettings: 'agentforce',
    MLRecommendationDefinition: 'agentforce',
    CallCoachingMediaProvider: 'agentforce',
    GenAiPlanner: 'agentforce',
    GenAiPlannerBundle: 'agentforce',
    ConversationContextVariable: 'agentforce',
    BotTemplate: 'agentforce',
    BotSettings: 'agentforce',
    GenAiPlugin: 'agentforce',
    GenAiFunction: 'agentforce',
    GenAiPromptTemplate: 'agentforce',
    ConversationVariable: 'agentforce',

    // Automation
    Flow: 'automation',
    WorkflowRule: 'automation',
    ApprovalProcess: 'automation',
    AssignmentRule: 'automation',
    AutoResponseRule: 'automation',
    EscalationRule: 'automation',
    MatchingRule: 'automation',
    DuplicateRule: 'automation',
    PathAssistant: 'automation',
    MacroSettings: 'automation',
    RecommendationStrategy: 'automation',
    NextBestAction: 'automation',
    EntitlementProcess: 'automation',
    MilestoneType: 'automation',
    ProcessBuilder: 'automation',
    BigObjectIndex: 'automation',
    CustomNotificationType: 'automation',
    UserCriteria: 'automation',
    WorkflowAlert: 'automation',
    WorkflowFieldUpdate: 'automation',
    WorkflowOutboundMessage: 'automation',
    WorkflowSend: 'automation',
    WorkflowTask: 'automation',
    WorkflowKnowledgePublish: 'automation',
    AssignmentRules: 'automation',
    AutoResponseRules: 'automation',
    EscalationRules: 'automation',
    MatchingRules: 'automation',
    Workflow: 'automation',
    WorkflowFlowAutomation: 'automation',
    ProcessFlowMigration: 'automation',
    FlowCategory: 'automation',
    FlowDefinition: 'automation',
    FlowTest: 'automation',
    EntitlementTemplate: 'automation',
    PostTemplate: 'automation',
    ConversationMessageDefinition: 'automation',
    ConvIntelligenceSignalRule: 'automation',

    // Code
    ApexClass: 'code',
    ApexTrigger: 'code',
    ApexComponent: 'code',
    ApexPage: 'code',
    AuraDefinitionBundle: 'code',
    LightningComponentBundle: 'code',
    StaticResource: 'code',
    ApexTestSuite: 'code',
    ApexExecutionOverlayAction: 'code',
    ApexLog: 'code',
    TraceFlag: 'code',
    ApexEmailNotifications: 'code',
    Scontrol: 'code',

    // Integration
    ConnectedApp: 'integration',
    RemoteSiteSetting: 'integration',
    NamedCredential: 'integration',
    ExternalServiceRegistration: 'integration',
    OutboundMessage: 'integration',
    CallCenter: 'integration',
    DataConnectorS3: 'integration',
    PlatformEventSubscriberConfig: 'integration',
    StreamingChannel: 'integration',
    PushTopic: 'integration',
    EventBus: 'integration',
    ChangeDataCapture: 'integration',
    ApiVersion: 'integration',
    RestResource: 'integration',
    SoapService: 'integration',
    ExternalService: 'integration',
    WebLink: 'integration',
    DataImportMapping: 'integration',
    IntegrationProviderDef: 'integration',
    PaymentGatewayProvider: 'integration',
    CommerceSettings: 'integration',
    MktDataConnection: 'integration',
    MktDataStream: 'integration',
    CanvasMetadata: 'integration',
    EmailServicesFunction: 'integration',
    DataWeaveResource: 'integration',
    ExternalDataSrcDescriptor: 'integration',
    ManagedEventSubscription: 'integration',
    PlatformCachePartition: 'integration',
    BriefcaseDefinition: 'integration',
    ManagedContentType: 'integration',
    GatewayProviderPaymentMethodType: 'integration',
    EclairGeoData: 'integration',
    InstalledPackage: 'integration',

    // Schema
    RecordType: 'schema',
    BusinessProcess: 'schema',
    FieldSet: 'schema',
    GlobalValueSet: 'schema',
    StandardValueSet: 'schema',
    ExternalDataSource: 'schema',
    CustomIndex: 'schema',
    PlatformEventChannel: 'schema',
    PlatformEventChannelMember: 'schema',
    EventRelayConfig: 'schema',
    EventDelivery: 'schema',
    BigObject: 'schema',
    HistoryRetentionPolicy: 'schema',
    CompactLayoutAssignment: 'schema',
    SearchLayouts: 'schema',
    SharingReason: 'schema',
    ValidationRule: 'schema',
    LookupFilter: 'schema',
    Formula: 'schema',
    RollupSummary: 'schema',
    CustomSettings: 'schema',
    GlobalPicklist: 'schema',
    CustomValue: 'schema',
    StandardValue: 'schema',
    PicklistValue: 'schema',
    DataCategoryGroup: 'schema',
    TopicsForObjects: 'schema',
    SynonymDictionary: 'schema',
    SearchCustomization: 'schema',
    SearchOrgWideObjectConfig: 'schema',
    Index: 'schema',
    CustomLabels: 'schema',
    AnalyticSnapshot: 'schema',
    WaveAnalyticAssetCollection: 'schema',
    ChoiceList: 'schema',
    CleanDataService: 'schema',
    LeadConvertSettings: 'schema',

    // Security
    Profile: 'security',
    PermissionSet: 'security',
    PermissionSetGroup: 'security',
    Role: 'security',
    Group: 'security',
    Queue: 'security',
    SharingRules: 'security',
    SharingCriteriaRule: 'security',
    SharingOwnerRule: 'security',
    SharingGuestRule: 'security',
    CustomPermission: 'security',
    UserAccessPolicy: 'security',
    Territory2: 'security',
    Territory2Type: 'security',
    Territory2Model: 'security',
    Territory2Rule: 'security',
    AuthProvider: 'security',
    SecuritySettings: 'security',
    SessionSettings: 'security',
    PasswordPolicy: 'security',
    MobileSecurityAssignment: 'security',
    TransactionSecurityPolicy: 'security',
    NetworkBranding: 'security',
    CorsWhitelistOrigin: 'security',
    CspTrustedSite: 'security',
    IpRange: 'security',
    LoginFlow: 'security',
    OAuth2ClientCredentialsFlow: 'security',
    UserAuthCertificate: 'security',
    PlatformEncryption: 'security',
    FieldServiceSettings: 'security',
    Settings: 'security',
    FeatureParameter: 'security',
    FeatureParameterBoolean: 'security',
    FeatureParameterDate: 'security',
    FeatureParameterInteger: 'security',
    FieldRestrictionRule: 'security',
    RestrictionRule: 'security',
    Certificate: 'security',
    PublicKeyCertificate: 'security',
    PublicKeyCertificateSet: 'security',
    SamlSsoConfig: 'security',
    ExternalAuthIdentityProvider: 'security',
    ExternalClientApplication: 'security',
    ExternalCredential: 'security',
    OauthCustomScope: 'security',
    OauthTokenExchangeHandler: 'security',
    MyDomainDiscoverableLogin: 'security',
    ProfilePasswordPolicy: 'security',
    ProfileSessionSetting: 'security',
    MutingPermissionSet: 'security',
    SharingSet: 'security',
    IPAddressRange: 'security',
    InboundNetworkConnection: 'security',
    OutboundNetworkConnection: 'security',
    IframeWhiteListUrlSettings: 'security',
    RedirectWhitelistUrl: 'security',
    UserProvisioningConfig: 'security',
    BlacklistedConsumer: 'security',
    ExtlClntAppConfigurablePolicies: 'security',
    ExtlClntAppGlobalOauthSettings: 'security',
    ExtlClntAppOauthConfigurablePolicies: 'security',
    ExtlClntAppOauthSettings: 'security',
    LiveChatSensitiveDataRule: 'security',
    DelegateGroup: 'security',
    NotificationTypeConfig: 'security',

    // User Interface
    Layout: 'user-interface',
    CompactLayout: 'user-interface',
    ListView: 'user-interface',
    CustomApplication: 'user-interface',
    CustomTab: 'user-interface',
    FlexiPage: 'user-interface',
    LightningExperienceTheme: 'user-interface',
    HomePageLayout: 'user-interface',
    HomePageComponent: 'user-interface',
    ReportType: 'user-interface',
    Dashboard: 'user-interface',
    Report: 'user-interface',
    Document: 'user-interface',
    ContentAsset: 'user-interface',
    CustomPageWebLink: 'user-interface',
    Letterhead: 'user-interface',
    EmailTemplate: 'user-interface',
    CommunityTemplateDefinition: 'user-interface',
    CommunityThemeDefinition: 'user-interface',
    ExperienceBundle: 'user-interface',
    OmniScript: 'user-interface',
    OmniUiCard: 'user-interface',
    OmniDataTransform: 'user-interface',
    OmniIntegrationProcedure: 'user-interface',
    EmbeddedServiceConfig: 'user-interface',
    EmbeddedServiceBranding: 'user-interface',
    AnimationRule: 'user-interface',
    LightningBolt: 'user-interface',
    LightningMessageChannel: 'user-interface',
    CustomHelpMenuSection: 'user-interface',
    CustomLabel: 'user-interface',
    Translations: 'user-interface',
    CustomObjectTranslation: 'user-interface',
    GlobalValueSetTranslation: 'user-interface',
    Audience: 'user-interface',
    AppMenu: 'user-interface',
    ActionLauncherItemDef: 'user-interface',
    ActionLinkGroupTemplate: 'user-interface',
    QuickAction: 'user-interface',
    RecordActionDeployment: 'user-interface',
    ChannelLayout: 'user-interface',
    CustomApplicationComponent: 'user-interface',
    ChatterExtension: 'user-interface',
    CustomFeedFilter: 'user-interface',
    BrandingSet: 'user-interface',
    DigitalExperience: 'user-interface',
    DigitalExperienceBundle: 'user-interface',
    ExperienceContainer: 'user-interface',
    ExperiencePropertyTypeBundle: 'user-interface',
    Community: 'user-interface',
    CustomSite: 'user-interface',
    SiteDotCom: 'user-interface',
    LightningOnboardingConfig: 'user-interface',
    UiFormatSpecificationSet: 'user-interface',
    Prompt: 'user-interface',
    MobileApplicationDetail: 'user-interface',
  };

  return tableMapping[metadataType] || ALL_CATEGORY;
};
